var render = function render(){var _vm=this,_c=_vm._self._c;return _c('universal-search',{attrs:{"app-shareable":"","save-filters-to-url":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }